import { CountryFlagIcon } from "@msuite/ui/country-flag-icon";
import { ColorPicker, Select, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import { countryList } from "@msuite/utils/misc";
import type { OrganizationFormType } from "@msuite/utils/schemas";
import React from "react";
import { useFormContext } from "react-hook-form";

export function OrganizationForm() {
	/** Context */
	const methods = useFormContext<OrganizationFormType>();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<React.Fragment>
			<TextInput
				control={methods.control}
				isRequired
				name="name"
				label={t("organization.organization")}
				placeholder={t("placeholders.organization")}
				data-cy="organization-name-input"
			/>
			<Select
				label={t("organization.organization_size")}
				isNullable={false}
				isRequired
				control={methods.control}
				name="size"
				options={[
					{ label: "1-10", value: "1-10", item: null },
					{ label: "11-50", value: "11-50", item: null },
					{ label: "51-200", value: "51-200", item: null },
					{ label: "201-500", value: "201-500", item: null },
					{ label: "501-1000", value: "501-1000", item: null },
					{ label: "1001-5000", value: "1001-5000", item: null },
					{ label: "5000+", value: "5000+", item: null },
				]}
				itemNotFoundLabel={undefined}
				data-cy="organization-size-select"
			/>
			<Select
				label={t("address.country")}
				isRequired
				isNullable={false}
				control={methods.control}
				name="country"
				options={countryList.map((country) => ({
					label: country.name,
					value: country.code,
					item: country,
				}))}
				renderOption={(option) => (
					<div className="h-stack">
						<CountryFlagIcon locale={option.code} />
						<p>{option.name}</p>
					</div>
				)}
				itemNotFoundLabel={undefined}
				data-cy="organization-country-select"
			/>
			<ColorPicker
				control={methods.control}
				isRequired
				name="color"
				label={t("organization.organization_color")}
			/>
		</React.Fragment>
	);
}
